export default __webpack_public_path__ + "static/media/rockPaper.6ac07e5a.gif";